import {foundationTheme, getColorByPath, type ThemeColorPath} from 'platform/foundation';

// A missing token prints black, so the gap shows instead of a silently wrong colour.
const MISSING_TOKEN_COLOR = '#000000';

const resolve = (color: ThemeColorPath) =>
  getColorByPath(color, foundationTheme) ?? MISSING_TOKEN_COLOR;

/**
 * Colours of the chart frame in the print document, from the tokens of the charts on screen.
 * The series colours come with each section.
 */
export const DOCUMENT_CHART_COLORS = {
  grid: resolve('palettes.neutral.30.100'),
  axisLabel: resolve('text.secondary'),
  referenceLine: resolve('palettes.neutral.50.100'),
} as const;
